<p-toast position="bottom-right" [baseZIndex]="300000"></p-toast>
<p-confirmDialog [baseZIndex]="200000"></p-confirmDialog>

<div class="container-fluid mt-2 nbs-extrator">
  <p-panel header="NBS Extrator" styleClass="p-shadow-3">
    <ng-template pTemplate="icons">
      <span class="p-input-icon-left filtro-geral">
        <i class="pi pi-search"></i>
        <input pInputText type="text" placeholder="Filtro Geral..."
          (input)="filtrarGeral($event.target.value)">
      </span>
    </ng-template>
  <div class="abas-extrator">
    <button pButton pRipple type="button" [icon]="atualizando ? 'pi pi-refresh pi-spin' : 'pi pi-refresh'"
      class="p-button-rounded botao-atualizar" pTooltip="Atualizar" tooltipPosition="left"
      [disabled]="atualizando" (click)="atualizar()"></button>
  <p-tabView>
    <p-tabPanel header="Monitor">
      <p class="sem-monitor" *ngIf="operacoesMonitor.length === 0">
        Nenhuma operação marcada para o Monitor.
      </p>
      <p-tabView *ngIf="operacoesMonitor.length > 0" [activeIndex]="indiceMonitor" (onChange)="guardarAbaMonitor($event.index)">
        <p-tabPanel *ngFor="let operacao of operacoesMonitor" [header]="operacao.descricao">
          <div class="barra-filtro">
            <button pButton type="button" icon="pi pi-filter" class="p-button-sm p-button-secondary"
              pTooltip="Definir Filtros" (click)="abrirFiltroMonitor(operacao.codOperacao)"></button>
          </div>

          <div class="grade-clientes" *ngIf="operacao.codOperacao === 8">
          <p-table [value]="clientesGrade" [autoLayout]="true"
            styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [paginator]="true" [rows]="rows"
            [rowsPerPageOptions]="rowsPerPageOptions" [showCurrentPageReport]="true"
            [currentPageReportTemplate]="paginaTemplate">
            <ng-template pTemplate="header">
              <tr>
                <th class="coluna-detalhe"></th>
                <th pSortableColumn="codMovimento">Cód. Movimento <p-sortIcon field="codMovimento"></p-sortIcon></th>
                <th class="col-empresa" pSortableColumn="nomeEmpresa">Empresa <p-sortIcon field="nomeEmpresa"></p-sortIcon></th>
                <th pSortableColumn="codCliente">Cód. Cliente <p-sortIcon field="codCliente"></p-sortIcon></th>
                <th class="col-nome" pSortableColumn="nome">Nome <p-sortIcon field="nome"></p-sortIcon></th>
                <th pSortableColumn="dataCadastro">Data cadastro <p-sortIcon field="dataCadastro"></p-sortIcon></th>
                <th pSortableColumn="tipoPessoa">Tipo pessoa <p-sortIcon field="tipoPessoa"></p-sortIcon></th>
                <th pSortableColumn="enviado">Enviado <p-sortIcon field="enviado"></p-sortIcon></th>
                <th pSortableColumn="status">Status <p-sortIcon field="status"></p-sortIcon></th>
                <th class="col-data" pSortableColumn="dataIntegracao">Data integração <p-sortIcon field="dataIntegracao"></p-sortIcon></th>
                <th class="col-data" pSortableColumn="dataUltimaAtualizacao">Última atualização <p-sortIcon field="dataUltimaAtualizacao"></p-sortIcon></th>
                <th pSortableColumn="errosEnvio">Erros envio <p-sortIcon field="errosEnvio"></p-sortIcon></th>
                <th pSortableColumn="marca">Marca <p-sortIcon field="marca"></p-sortIcon></th>
                <th class="coluna-reenviar">Ação</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-cliente>
              <tr>
                <td class="coluna-detalhe">
                  <button pButton pRipple
                    type="button"
                    icon="pi pi-file"
                    class="p-button-text p-button-plain p-btn-sm"
                    pTooltip="Detalhe"
                    (click)="abrirDetalheCliente(cliente)">
                  </button>
                </td>
                <td>{{ cliente.codMovimento }}</td>
                <td class="col-empresa">{{ cliente.nomeEmpresa }}</td>
                <td>{{ cliente.codCliente }}</td>
                <td class="col-nome">{{ cliente.nome }}</td>
                <td>{{ cliente.dataCadastro }}</td>
                <td>{{ cliente.tipoPessoa }}</td>
                <td>{{ rotuloEnviado(cliente.enviado) }}</td>
                <td>
                  <span *ngIf="cliente.status" class="status-badge" [ngClass]="classeStatus(cliente.status)">{{ cliente.status }}</span>
                </td>
                <td class="col-data">{{ cliente.dataIntegracao }}</td>
                <td class="col-data">{{ cliente.dataUltimaAtualizacao }}</td>
                <td>{{ cliente.errosEnvio }}</td>
                <td>{{ cliente.marca }}</td>
                <td class="coluna-reenviar">
                  <button pButton type="button" icon="pi pi-replay" label="Reenviar"
                    class="p-button-outlined p-button-sm botao-reenviar"
                    (click)="reenviarCliente(cliente)"></button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="14">{{ mensagemGrade(8) }}</td>
              </tr>
            </ng-template>
          </p-table>
          </div>
          <div class="legenda-status" *ngIf="operacao.codOperacao === 8">
            <span *ngFor="let item of legendaStatus" class="legenda-item" [ngClass]="item.classe">
              <i></i>
              {{ item.status }}<ng-container *ngIf="quantidadeStatus(item.status) > 0">({{ quantidadeStatus(item.status) }})</ng-container>
            </span>
            <button pButton type="button" label="Reenviar" icon="pi pi-replay"
              class="p-button-text p-button-sm p-button-plain legenda-reenviar"
              (click)="abrirMenuReenvio(menuReenviar, $event, 8)"></button>
          </div>

          <div class="grade-clientes" *ngIf="operacao.codOperacao === 9">
          <p-table [value]="produtivosGrade" [autoLayout]="true"
            styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [paginator]="true" [rows]="rows"
            [rowsPerPageOptions]="rowsPerPageOptions" [showCurrentPageReport]="true"
            [currentPageReportTemplate]="paginaTemplate">
            <ng-template pTemplate="header">
              <tr>
                <th class="coluna-detalhe"></th>
                <th pSortableColumn="codMovimento">Cód. Movimento <p-sortIcon field="codMovimento"></p-sortIcon></th>
                <th class="col-empresa" pSortableColumn="nomeEmpresa">Empresa <p-sortIcon field="nomeEmpresa"></p-sortIcon></th>
                <th pSortableColumn="codTecnico">Cód. Técnico <p-sortIcon field="codTecnico"></p-sortIcon></th>
                <th class="col-nome" pSortableColumn="nome">Nome do técnico <p-sortIcon field="nome"></p-sortIcon></th>
                <th pSortableColumn="cpf">CPF <p-sortIcon field="cpf"></p-sortIcon></th>
                <th pSortableColumn="dataAdmissao">Data admissão <p-sortIcon field="dataAdmissao"></p-sortIcon></th>
                <th pSortableColumn="enviado">Enviado <p-sortIcon field="enviado"></p-sortIcon></th>
                <th pSortableColumn="status">Status <p-sortIcon field="status"></p-sortIcon></th>
                <th class="col-data" pSortableColumn="dataIntegracao">Data integração <p-sortIcon field="dataIntegracao"></p-sortIcon></th>
                <th pSortableColumn="errosEnvio">Erros envio <p-sortIcon field="errosEnvio"></p-sortIcon></th>
                <th pSortableColumn="marca">Marca <p-sortIcon field="marca"></p-sortIcon></th>
                <th class="coluna-reenviar">Ação</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-produtivo>
              <tr>                
                <td class="coluna-detalhe">
                  <button pButton pRipple
                    type="button"
                    icon="pi pi-file"
                    class="p-button-text p-button-plain p-btn-sm"
                    pTooltip="Detalhe"
                    (click)="abrirDetalheProdutivo(produtivo)">
                  </button>
                </td>
                <td>{{ produtivo.codMovimento }}</td>
                <td class="col-empresa">{{ produtivo.nomeEmpresa }}</td>
                <td>{{ produtivo.codTecnico }}</td>
                <td class="col-nome">{{ produtivo.nome }}</td>
                <td>{{ produtivo.cpf }}</td>
                <td>{{ produtivo.dataAdmissao }}</td>
                <td>{{ rotuloEnviado(produtivo.enviado) }}</td>
                <td>
                  <span *ngIf="produtivo.status" class="status-badge" [ngClass]="classeStatus(produtivo.status)">{{ produtivo.status }}</span>
                </td>
                <td class="col-data">{{ produtivo.dataIntegracao }}</td>
                <td>{{ produtivo.errosEnvio }}</td>
                <td>{{ produtivo.marca }}</td>
                <td class="coluna-reenviar">
                  <button pButton type="button" icon="pi pi-replay" label="Reenviar"
                    class="p-button-outlined p-button-sm botao-reenviar"
                    (click)="reenviarProdutivo(produtivo)"></button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="13">{{ mensagemGrade(9) }}</td>
              </tr>
            </ng-template>
          </p-table>
          </div>
          <div class="legenda-status" *ngIf="operacao.codOperacao === 9">
            <span *ngFor="let item of legendaStatus" class="legenda-item" [ngClass]="item.classe">
              <i></i>
              {{ item.status }}<ng-container *ngIf="quantidadeStatusProdutivo(item.status) > 0">({{ quantidadeStatusProdutivo(item.status) }})</ng-container>
            </span>
            <button pButton type="button" label="Reenviar" icon="pi pi-replay"
              class="p-button-text p-button-sm p-button-plain legenda-reenviar"
              (click)="abrirMenuReenvio(menuReenviar, $event, 9)"></button>
          </div>

          <div class="grade-clientes" *ngIf="operacao.codOperacao === 12">
          <p-table [value]="comprasGrade" [autoLayout]="true"
            styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [paginator]="true" [rows]="rows"
            [rowsPerPageOptions]="rowsPerPageOptions" [showCurrentPageReport]="true"
            [currentPageReportTemplate]="paginaTemplate">
            <ng-template pTemplate="header">
              <tr>
                <th class="coluna-detalhe"></th>
                <th pSortableColumn="codMovimento">Cód. Movimento <p-sortIcon field="codMovimento"></p-sortIcon></th>
                <th class="col-empresa" pSortableColumn="nomeEmpresa">Empresa <p-sortIcon field="nomeEmpresa"></p-sortIcon></th>
                <th pSortableColumn="codControle">Cód. Controle <p-sortIcon field="codControle"></p-sortIcon></th>
                <th pSortableColumn="numero">Número <p-sortIcon field="numero"></p-sortIcon></th>
                <th pSortableColumn="serie">Série <p-sortIcon field="serie"></p-sortIcon></th>
                <th pSortableColumn="dataEmissao">Data emissão <p-sortIcon field="dataEmissao"></p-sortIcon></th>
                <th pSortableColumn="enviado">Enviado <p-sortIcon field="enviado"></p-sortIcon></th>
                <th pSortableColumn="status">Status <p-sortIcon field="status"></p-sortIcon></th>
                <th class="col-data" pSortableColumn="dataIntegracao">Data integração <p-sortIcon field="dataIntegracao"></p-sortIcon></th>
                <th class="col-data" pSortableColumn="dataUltimaAtualizacao">Última atualização <p-sortIcon field="dataUltimaAtualizacao"></p-sortIcon></th>
                <th pSortableColumn="errosEnvio">Erros envio <p-sortIcon field="errosEnvio"></p-sortIcon></th>
                <th pSortableColumn="marca">Marca <p-sortIcon field="marca"></p-sortIcon></th>
                <th class="coluna-reenviar">Ação</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-compra>
              <tr>
                <td class="coluna-detalhe">
                  <button pButton pRipple type="button" icon="pi pi-file"
                    class="p-button-rounded p-button-secondary p-btn-sm" pTooltip="Detalhe"
                    (click)="abrirDetalheCompra(compra)"></button>
                </td>
                <td>{{ compra.codMovimento }}</td>
                <td class="col-empresa">{{ compra.nomeEmpresa }}</td>
                <td>{{ compra.codControle }}</td>
                <td>{{ compra.numero }}</td>
                <td>{{ compra.serie }}</td>
                <td>{{ compra.dataEmissao }}</td>
                <td>{{ rotuloEnviado(compra.enviado) }}</td>
                <td>
                  <span *ngIf="compra.status" class="status-badge" [ngClass]="classeStatus(compra.status)">{{ compra.status }}</span>
                </td>
                <td class="col-data">{{ compra.dataIntegracao }}</td>
                <td class="col-data">{{ compra.dataUltimaAtualizacao }}</td>
                <td>{{ compra.errosEnvio }}</td>
                <td>{{ compra.marca }}</td>
                <td class="coluna-reenviar">
                  <button pButton type="button" icon="pi pi-replay" label="Reenviar"
                    class="p-button-outlined p-button-sm botao-reenviar"
                    (click)="reenviarCompra(compra)"></button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="14">{{ mensagemGrade(12) }}</td>
              </tr>
            </ng-template>
          </p-table>
          </div>
          <div class="legenda-status" *ngIf="operacao.codOperacao === 12">
            <span *ngFor="let item of legendaStatus" class="legenda-item" [ngClass]="item.classe">
              <i></i>
              {{ item.status }}<ng-container *ngIf="quantidadeStatusCompra(item.status) > 0">({{ quantidadeStatusCompra(item.status) }})</ng-container>
            </span>
            <button pButton type="button" label="Reenviar" icon="pi pi-replay"
              class="p-button-text p-button-sm p-button-plain legenda-reenviar"
              (click)="abrirMenuReenvio(menuReenviar, $event, 12)"></button>
          </div>

          <div class="grade-clientes" *ngIf="operacao.codOperacao === 7">
          <p-table [value]="balcaoGrade" [autoLayout]="true"
            styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [paginator]="true" [rows]="rows"
            [rowsPerPageOptions]="rowsPerPageOptions" [showCurrentPageReport]="true"
            [currentPageReportTemplate]="paginaTemplate">
            <ng-template pTemplate="header">
              <tr>
                <th class="coluna-detalhe"></th>
                <th pSortableColumn="codMovimento">Cód. Movimento <p-sortIcon field="codMovimento"></p-sortIcon></th>
                <th class="col-empresa" pSortableColumn="nomeEmpresa">Empresa <p-sortIcon field="nomeEmpresa"></p-sortIcon></th>
                <th pSortableColumn="numero">Número <p-sortIcon field="numero"></p-sortIcon></th>
                <th pSortableColumn="serie">Série <p-sortIcon field="serie"></p-sortIcon></th>
                <th pSortableColumn="dataEmissao">Data emissão <p-sortIcon field="dataEmissao"></p-sortIcon></th>
                <th class="col-nome" pSortableColumn="vendedor">Vendedor <p-sortIcon field="vendedor"></p-sortIcon></th>
                <th pSortableColumn="cpfVendedor">CPF Vendedor <p-sortIcon field="cpfVendedor"></p-sortIcon></th>
                <th pSortableColumn="enviado">Enviado <p-sortIcon field="enviado"></p-sortIcon></th>
                <th pSortableColumn="status">Status <p-sortIcon field="status"></p-sortIcon></th>
                <th class="col-data" pSortableColumn="dataIntegracao">Data integração <p-sortIcon field="dataIntegracao"></p-sortIcon></th>
                <th class="col-data" pSortableColumn="dataUltimaAtualizacao">Última atualização <p-sortIcon field="dataUltimaAtualizacao"></p-sortIcon></th>
                <th pSortableColumn="errosEnvio">Erros envio <p-sortIcon field="errosEnvio"></p-sortIcon></th>
                <th pSortableColumn="marca">Marca <p-sortIcon field="marca"></p-sortIcon></th>
                <th class="coluna-reenviar">Ação</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-balcao>
              <tr>
                <td class="coluna-detalhe">
                  <button pButton pRipple type="button" icon="pi pi-file"
                    class="p-button-rounded p-button-secondary p-btn-sm" pTooltip="Detalhe"
                    (click)="abrirDetalheBalcao(balcao)"></button>
                </td>
                <td>{{ balcao.codMovimento }}</td>
                <td class="col-empresa">{{ balcao.nomeEmpresa }}</td>
                <td>{{ balcao.numero }}</td>
                <td>{{ balcao.serie }}</td>
                <td>{{ balcao.dataEmissao }}</td>
                <td class="col-nome">{{ balcao.vendedor }}</td>
                <td>{{ balcao.cpfVendedor }}</td>
                <td>{{ rotuloEnviado(balcao.enviado) }}</td>
                <td>
                  <span *ngIf="balcao.status" class="status-badge" [ngClass]="classeStatus(balcao.status)">{{ balcao.status }}</span>
                </td>
                <td class="col-data">{{ balcao.dataIntegracao }}</td>
                <td class="col-data">{{ balcao.dataUltimaAtualizacao }}</td>
                <td>{{ balcao.errosEnvio }}</td>
                <td>{{ balcao.marca }}</td>
                <td class="coluna-reenviar">
                  <button pButton type="button" icon="pi pi-replay" label="Reenviar"
                    class="p-button-outlined p-button-sm botao-reenviar"
                    (click)="reenviarBalcao(balcao)"></button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="15">{{ mensagemGrade(7) }}</td>
              </tr>
            </ng-template>
          </p-table>
          </div>
          <div class="legenda-status" *ngIf="operacao.codOperacao === 7">
            <span *ngFor="let item of legendaStatus" class="legenda-item" [ngClass]="item.classe">
              <i></i>
              {{ item.status }}<ng-container *ngIf="quantidadeStatusBalcao(item.status) > 0">({{ quantidadeStatusBalcao(item.status) }})</ng-container>
            </span>
            <button pButton type="button" label="Reenviar" icon="pi pi-replay"
              class="p-button-text p-button-sm p-button-plain legenda-reenviar"
              (click)="abrirMenuReenvio(menuReenviar, $event, 7)"></button>
          </div>

          <div class="grade-clientes" *ngIf="operacao.codOperacao === 10">
          <p-table [value]="ordensGrade" [autoLayout]="true"
            styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [paginator]="true" [rows]="rows"
            [rowsPerPageOptions]="rowsPerPageOptions" [showCurrentPageReport]="true"
            [currentPageReportTemplate]="paginaTemplate">
            <ng-template pTemplate="header">
              <tr>
                <th class="coluna-detalhe"></th>
                <th pSortableColumn="codMovimento">Cód. Movimento <p-sortIcon field="codMovimento"></p-sortIcon></th>
                <th class="col-empresa" pSortableColumn="nomeEmpresa">Empresa <p-sortIcon field="nomeEmpresa"></p-sortIcon></th>
                <th pSortableColumn="numeroOs">Número O.S. <p-sortIcon field="numeroOs"></p-sortIcon></th>
                <th pSortableColumn="idNumeroOs">ID Número O.S. <p-sortIcon field="idNumeroOs"></p-sortIcon></th>
                <th pSortableColumn="descTipoOs">Tipo O.S. <p-sortIcon field="descTipoOs"></p-sortIcon></th>
                <th class="col-nome" pSortableColumn="consultor">Consultor <p-sortIcon field="consultor"></p-sortIcon></th>
                <th pSortableColumn="enviado">Enviado <p-sortIcon field="enviado"></p-sortIcon></th>
                <th pSortableColumn="status">Status <p-sortIcon field="status"></p-sortIcon></th>
                <th class="col-data" pSortableColumn="dataIntegracao">Data integração <p-sortIcon field="dataIntegracao"></p-sortIcon></th>
                <th class="col-data" pSortableColumn="dataUltimaAtualizacao">Data atualização <p-sortIcon field="dataUltimaAtualizacao"></p-sortIcon></th>
                <th pSortableColumn="errosEnvio">Erros de envio <p-sortIcon field="errosEnvio"></p-sortIcon></th>
                <th pSortableColumn="marca">Marca <p-sortIcon field="marca"></p-sortIcon></th>
                <th class="coluna-reenviar">Ação</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-ordem>
              <tr>
                <td class="coluna-detalhe">
                  <button pButton pRipple type="button" icon="pi pi-file"
                    class="p-button-rounded p-button-secondary p-btn-sm" pTooltip="Detalhe"
                    (click)="abrirDetalheOs(ordem)"></button>
                </td>
                <td>{{ ordem.codMovimento }}</td>
                <td class="col-empresa">{{ ordem.nomeEmpresa }}</td>
                <td>{{ ordem.numeroOs }}</td>
                <td>{{ ordem.idNumeroOs }}</td>
                <td>{{ ordem.descTipoOs }}</td>
                <td class="col-nome">{{ ordem.consultor }}</td>
                <td>{{ rotuloEnviado(ordem.enviado) }}</td>
                <td>
                  <span *ngIf="ordem.status" class="status-badge" [ngClass]="classeStatus(ordem.status)">{{ ordem.status }}</span>
                </td>
                <td class="col-data">{{ ordem.dataIntegracao }}</td>
                <td class="col-data">{{ ordem.dataUltimaAtualizacao }}</td>
                <td>{{ ordem.errosEnvio }}</td>
                <td>{{ ordem.marca }}</td>
                <td class="coluna-reenviar">
                  <button pButton type="button" icon="pi pi-replay" label="Reenviar"
                    class="p-button-outlined p-button-sm botao-reenviar"
                    (click)="reenviarOs(ordem)"></button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="14">{{ mensagemGrade(10) }}</td>
              </tr>
            </ng-template>
          </p-table>
          </div>
          <div class="legenda-status" *ngIf="operacao.codOperacao === 10">
            <span *ngFor="let item of legendaStatus" class="legenda-item" [ngClass]="item.classe">
              <i></i>
              {{ item.status }}<ng-container *ngIf="quantidadeStatusOs(item.status) > 0">({{ quantidadeStatusOs(item.status) }})</ng-container>
            </span>
            <button pButton type="button" label="Reenviar" icon="pi pi-replay"
              class="p-button-text p-button-sm p-button-plain legenda-reenviar"
              (click)="abrirMenuReenvio(menuReenviar, $event, 10)"></button>
          </div>

          <div class="grade-clientes" *ngIf="operacaoExtra(operacao.codOperacao)">
          <p-table [value]="gradeOperacao(operacao.codOperacao)" [autoLayout]="true"
            styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [paginator]="true" [rows]="rows"
            [rowsPerPageOptions]="rowsPerPageOptions" [showCurrentPageReport]="true"
            [currentPageReportTemplate]="paginaTemplate">
            <ng-template pTemplate="header">
              <tr>
                <th class="coluna-detalhe"></th>
                <th *ngFor="let coluna of colunasOperacao(operacao.codOperacao)" [pSortableColumn]="coluna.campo">
                  {{ coluna.titulo }} <p-sortIcon [field]="coluna.campo"></p-sortIcon>
                </th>
                <th class="coluna-reenviar">Ação</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr>
                <td class="coluna-detalhe">
                  <button pButton pRipple type="button" icon="pi pi-file"
                    class="p-button-rounded p-button-secondary p-btn-sm" pTooltip="Detalhe"
                    (click)="abrirDetalheOperacao(item)"></button>
                </td>
                <td *ngFor="let coluna of colunasOperacao(operacao.codOperacao)">
                  <span *ngIf="coluna.tipo === 'status' && item[coluna.campo]" class="status-badge" [ngClass]="classeStatus(item[coluna.campo])">{{ item[coluna.campo] }}</span>
                  <ng-container *ngIf="coluna.tipo !== 'status'">{{ valorColuna(item, coluna) }}</ng-container>
                </td>
                <td class="coluna-reenviar">
                  <button pButton type="button" icon="pi pi-replay" label="Reenviar"
                    class="p-button-outlined p-button-sm botao-reenviar"
                    (click)="reenviarOperacao(item)"></button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="colunasOperacao(operacao.codOperacao).length + 2">{{ mensagemGrade(operacao.codOperacao) }}</td>
              </tr>
            </ng-template>
          </p-table>
          </div>
          <div class="legenda-status" *ngIf="operacaoExtra(operacao.codOperacao)">
            <span *ngFor="let item of legendaStatus" class="legenda-item" [ngClass]="item.classe">
              <i></i>
              {{ item.status }}<ng-container *ngIf="quantidadeStatusOperacao(operacao.codOperacao, item.status) > 0">({{ quantidadeStatusOperacao(operacao.codOperacao, item.status) }})</ng-container>
            </span>
            <button pButton type="button" label="Reenviar" icon="pi pi-replay"
              class="p-button-text p-button-sm p-button-plain legenda-reenviar"
              (click)="abrirMenuReenvio(menuReenviar, $event, operacao.codOperacao)"></button>
          </div>

          <p-table *ngIf="!monitorReal(operacao.codOperacao)" [value]="movimentosMonitor"
            styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [paginator]="true" [rows]="rows"
            [rowsPerPageOptions]="rowsPerPageOptions" [showCurrentPageReport]="true"
            [currentPageReportTemplate]="paginaTemplate">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="codMovimento">Cód. Movimento <p-sortIcon field="codMovimento"></p-sortIcon></th>
                <th pSortableColumn="empresa">Empresa <p-sortIcon field="empresa"></p-sortIcon></th>
                <th pSortableColumn="registro">Registro <p-sortIcon field="registro"></p-sortIcon></th>
                <th pSortableColumn="descricao">Descrição <p-sortIcon field="descricao"></p-sortIcon></th>
                <th pSortableColumn="status">Status <p-sortIcon field="status"></p-sortIcon></th>
                <th pSortableColumn="dataIntegracao">Data Integração <p-sortIcon field="dataIntegracao"></p-sortIcon></th>
                <th pSortableColumn="dataUltimaAtualizacao">Última atualização <p-sortIcon field="dataUltimaAtualizacao"></p-sortIcon></th>
                <th pSortableColumn="errosEnvio">Erros envio <p-sortIcon field="errosEnvio"></p-sortIcon></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-movimento>
              <tr>
                <td>{{ movimento.codMovimento }}</td>
                <td>{{ movimento.empresa }}</td>
                <td>{{ movimento.registro }}</td>
                <td>{{ movimento.descricao }}</td>
                <td>{{ movimento.status }}</td>
                <td>{{ movimento.dataIntegracao }}</td>
                <td>{{ movimento.dataUltimaAtualizacao }}</td>
                <td>{{ movimento.errosEnvio }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="8">{{ mensagemGrade(operacao.codOperacao) }}</td>
              </tr>
            </ng-template>
          </p-table>
        </p-tabPanel>
      </p-tabView>
    </p-tabPanel>

    <p-tabPanel header="Parâmetros">
  <p-tabView>
    <p-tabPanel header="Empresa">
      <p-table [value]="empresasGrade" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [paginator]="true" [rows]="rows"
        [rowsPerPageOptions]="rowsPerPageOptions" [showCurrentPageReport]="true"
        [currentPageReportTemplate]="paginaTemplate">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="codEmpresa">Cód. Empresa <p-sortIcon field="codEmpresa"></p-sortIcon></th>
            <th pSortableColumn="nome">Empresa <p-sortIcon field="nome"></p-sortIcon></th>
            <th pSortableColumn="cnpj">CNPJ <p-sortIcon field="cnpj"></p-sortIcon></th>
            <th pSortableColumn="codDealer">Cód. Dealer <p-sortIcon field="codDealer"></p-sortIcon></th>
            <th pSortableColumn="ambiente">Ambiente <p-sortIcon field="ambiente"></p-sortIcon></th>
            <th pSortableColumn="ativo">Ativo <p-sortIcon field="ativo"></p-sortIcon></th>
            <th pSortableColumn="situacao">Situação <p-sortIcon field="situacao"></p-sortIcon></th>
            <th class="coluna-acoes">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-empresa>
          <tr>
            <td>{{ empresa.codEmpresa }}</td>
            <td>{{ empresa.nome }}</td>
            <td>{{ empresa.cnpj }}</td>
            <td>{{ empresa.codDealer }}</td>
            <td>{{ empresa.ambiente }}</td>
            <td>{{ empresa.ativo ? 'Sim' : 'Não' }}</td>
            <td [pTooltip]="empresa.mensagem">{{ situacaoEmpresa(empresa) }}</td>
            <td class="coluna-acoes">
              <button pButton pRipple type="button" icon="pi pi-file"
                class="p-button-rounded p-button-secondary p-btn-sm p-mr-1" pTooltip="Detalhe"
                (click)="abrirEmpresa(empresa)"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8">Nenhuma empresa sincronizada de dealer cadastrado.</td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>

    <p-tabPanel header="Operação">
      <div class="barra-acoes">
        <button pButton type="button" icon="pi pi-plus" class="p-button-sm p-button-success" pTooltip="Adicionar"
          (click)="abrirOperacao()"></button>
      </div>
      <p-table [value]="operacoesGrade" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [paginator]="true" [rows]="rows"
        [rowsPerPageOptions]="rowsPerPageOptions" [showCurrentPageReport]="true"
        [currentPageReportTemplate]="paginaTemplate">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="codOperacao">Código <p-sortIcon field="codOperacao"></p-sortIcon></th>
            <th pSortableColumn="descricao">Descrição <p-sortIcon field="descricao"></p-sortIcon></th>
            <th pSortableColumn="ativo">Ativo <p-sortIcon field="ativo"></p-sortIcon></th>
            <th pSortableColumn="horario">Horário <p-sortIcon field="horario"></p-sortIcon></th>
            <th pSortableColumn="situacao">Situação <p-sortIcon field="situacao"></p-sortIcon></th>
            <th class="coluna-acoes">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-operacao>
          <tr>
            <td>{{ operacao.codOperacao }}</td>
            <td>{{ operacao.descricao }}</td>
            <td>{{ operacao.ativo ? 'Sim' : 'Não' }}</td>
            <td>{{ operacao.horario }}</td>
            <td [pTooltip]="operacao.mensagem">{{ situacaoOperacao(operacao) }}</td>
            <td class="coluna-acoes">
              <button pButton pRipple type="button" icon="pi pi-file"
                class="p-button-rounded p-button-secondary p-btn-sm p-mr-1" pTooltip="Detalhe"
                (click)="abrirOperacao(operacao)"></button>
              <button pButton pRipple type="button" icon="pi pi-trash"
                class="p-button-rounded p-button-danger p-btn-sm p-mr-1" pTooltip="Excluir"
                (click)="confirmarExclusaoOperacao(operacao)"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6">Nenhuma operação sincronizada de dealer cadastrado.</td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>

    <p-tabPanel header="Cruzamento">
      <div class="barra-acoes">
        <button pButton type="button" icon="pi pi-plus" class="p-button-sm p-button-success" pTooltip="Adicionar"
          (click)="abrirCruzamento()"></button>
      </div>
      <p-table [value]="cruzamentosGrade" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [paginator]="true" [rows]="rows"
        [rowsPerPageOptions]="rowsPerPageOptions" [showCurrentPageReport]="true"
        [currentPageReportTemplate]="paginaTemplate">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="codDealer">Cód. Dealer <p-sortIcon field="codDealer"></p-sortIcon></th>
            <th pSortableColumn="codEmpresa">Cód. Empresa <p-sortIcon field="codEmpresa"></p-sortIcon></th>
            <th pSortableColumn="nomeDealer">Nome Dealer <p-sortIcon field="nomeDealer"></p-sortIcon></th>
            <th pSortableColumn="codOperacao">Cód. Operação <p-sortIcon field="codOperacao"></p-sortIcon></th>
            <th pSortableColumn="operacao">Operação <p-sortIcon field="operacao"></p-sortIcon></th>
            <th pSortableColumn="ativo" class="coluna-ativo">Ativo <p-sortIcon field="ativo"></p-sortIcon></th>
            <th pSortableColumn="configurado">Configurado <p-sortIcon field="configurado"></p-sortIcon></th>
            <th pSortableColumn="situacao">Situação <p-sortIcon field="situacao"></p-sortIcon></th>
            <th class="coluna-acoes coluna-acoes-cruzamento">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-cruzamento>
          <tr>
            <td>{{ cruzamento.codDealer }}</td>
            <td>{{ cruzamento.codEmpresa }}</td>
            <td>{{ cruzamento.nomeDealer }}</td>
            <td>{{ cruzamento.codOperacao }}</td>
            <td>{{ cruzamento.operacao }}</td>
            <td>
              <div class="ativo-cruzamento">
                <p-checkbox [binary]="true" [ngModel]="cruzamento.ativo" [disabled]="true"></p-checkbox>
              </div>
            </td>
            <td>{{ cruzamento.configurado ? 'Sim' : 'Não' }}</td>
            <td [pTooltip]="cruzamento.mensagem">{{ situacaoCruzamento(cruzamento) }}</td>
            <td class="coluna-acoes coluna-acoes-cruzamento">
              <button pButton pRipple type="button" icon="pi pi-file"
                class="p-button-rounded p-button-secondary p-btn-sm p-mr-1" pTooltip="Detalhe"
                (click)="abrirCruzamento(cruzamento)"></button>
              <button pButton pRipple type="button" icon="pi pi-trash"
                class="p-button-rounded p-button-danger p-btn-sm p-mr-1" pTooltip="Excluir"
                (click)="confirmarExclusaoCruzamento(cruzamento)"></button>
              <button pButton pRipple type="button" icon="pi pi-cog"
                class="p-button-rounded p-button-info p-btn-sm p-mr-1" pTooltip="Configurar"
                (click)="abrirConfiguracao(cruzamento)"></button>
              <button *ngIf="!cruzamento.ativo" pButton pRipple type="button" icon="pi pi-play"
                class="p-button-rounded p-button-success p-btn-sm" pTooltip="Ativar"
                (click)="definirAtivoCruzamento(cruzamento, true)"></button>
              <button *ngIf="cruzamento.ativo" pButton pRipple type="button" icon="pi pi-stop"
                class="p-button-rounded p-button-warning p-btn-sm botao-stop" pTooltip="Desativar"
                (click)="definirAtivoCruzamento(cruzamento, false)"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="9">Nenhum cruzamento sincronizado de dealer cadastrado.</td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
  </p-tabView>
    </p-tabPanel>
  </p-tabView>
  </div>
  </p-panel>
</div>

<p-dialog header="Filtros" [(visible)]="exibirFiltroMonitor" [modal]="true" [style]="{width: '600px'}"
  [draggable]="false" position="top" styleClass="p-fluid dialog-filtro-extrator">
  <div class="campo">
    <label for="filtroEmpresa">Empresa</label>
    <p-multiSelect inputId="filtroEmpresa" [options]="monitorReal(operacaoFiltro) ? empresasSincronizadas : empresasAtivas" optionLabel="rotulo"
      [(ngModel)]="filtroEdicao.empresas" defaultLabel="Selecione as empresas" [filter]="true" filterBy="rotulo"
      [showToggleAll]="false" selectedItemsLabel="{0} empresas selecionadas" appendTo="body"
      [style]="{'width':'100%'}" [baseZIndex]="10000000"></p-multiSelect>
  </div>
  <div class="campo">
    <label for="filtroStatus">Status</label>
    <p-dropdown inputId="filtroStatus" [options]="monitorReal(operacaoFiltro) ? statusCliente : statusMonitor" optionLabel="label" optionValue="value"
      [(ngModel)]="filtroEdicao.status" placeholder="Selecione" [showClear]="true" appendTo="body"
      [style]="{'width':'100%'}"></p-dropdown>
  </div>
  <div class="campo">
    <label for="filtroTipoData">Filtro data</label>
    <p-dropdown inputId="filtroTipoData" [options]="opcoesTipoData(operacaoFiltro)" optionLabel="label" optionValue="value"
      [(ngModel)]="filtroEdicao.tipoData" placeholder="Selecione" [showClear]="true" appendTo="body"
      [style]="{'width':'100%'}"></p-dropdown>
  </div>
  <div class="campo-datas">
    <div class="campo">
      <label for="filtroDataInicial">De</label>
      <p-calendar inputId="filtroDataInicial" [(ngModel)]="filtroEdicao.dataInicial" dateFormat="dd/mm/yy"
        [showIcon]="true" icon="pi pi-calendar" [style]="{'width':'100%'}" [yearNavigator]="true"
        [monthNavigator]="true" yearRange="2000:2030" showButtonBar="true" appendTo="body"
        panelStyleClass="calendario-extrator" [baseZIndex]="10000000"></p-calendar>
    </div>
    <div class="campo">
      <label for="filtroDataFinal">Até</label>
      <p-calendar inputId="filtroDataFinal" [(ngModel)]="filtroEdicao.dataFinal" dateFormat="dd/mm/yy" [showIcon]="true"
        icon="pi pi-calendar" [style]="{'width':'100%'}" [yearNavigator]="true" [monthNavigator]="true"
        yearRange="2000:2030" showButtonBar="true" appendTo="body"
        panelStyleClass="calendario-extrator" [baseZIndex]="10000000"></p-calendar>
    </div>
  </div>
  <div class="campo" *ngIf="operacaoFiltro === 8">
    <label for="filtroTipoPessoa">Tipo pessoa</label>
    <p-dropdown inputId="filtroTipoPessoa" [options]="tiposPessoaCliente" optionLabel="label" optionValue="value"
      [(ngModel)]="filtroEdicao.tipoPessoa" placeholder="Selecione" [showClear]="true" appendTo="body"
      [style]="{'width':'100%'}"></p-dropdown>
  </div>
  <div class="campo" *ngIf="operacaoFiltro === 8">
    <label for="filtroCodigoCliente">Código</label>
    <input id="filtroCodigoCliente" pInputText type="text" [(ngModel)]="filtroEdicao.registro"
      placeholder="Filtrar por código">
  </div>
  <div class="campo" *ngIf="operacaoFiltro === 8">
    <label for="filtroNomeCliente">Nome</label>
    <input id="filtroNomeCliente" pInputText type="text" [(ngModel)]="filtroEdicao.descricao"
      placeholder="Filtrar por nome">
  </div>
  <div class="campo" *ngIf="operacaoFiltro === 9">
    <label for="filtroCpfProdutivo">CPF</label>
    <input id="filtroCpfProdutivo" pInputText type="text" [(ngModel)]="filtroEdicao.registro"
      placeholder="Filtrar por CPF">
  </div>
  <div class="campo" *ngIf="operacaoFiltro === 9">
    <label for="filtroNomeProdutivo">Nome</label>
    <input id="filtroNomeProdutivo" pInputText type="text" [(ngModel)]="filtroEdicao.descricao"
      placeholder="Filtrar por nome do técnico">
  </div>
  <div class="campo" *ngIf="operacaoFiltro === 12">
    <label for="filtroNumeroCompra">Número</label>
    <input id="filtroNumeroCompra" pInputText type="text" [(ngModel)]="filtroEdicao.registro"
      placeholder="Filtrar por número da nota">
  </div>
  <div class="campo" *ngIf="operacaoFiltro === 12">
    <label for="filtroControleCompra">Cód. Controle</label>
    <input id="filtroControleCompra" pInputText type="text" [(ngModel)]="filtroEdicao.descricao"
      placeholder="Filtrar por código de controle">
  </div>
  <div class="campo" *ngIf="operacaoFiltro === 7">
    <label for="filtroNumeroBalcao">Número</label>
    <input id="filtroNumeroBalcao" pInputText type="text" [(ngModel)]="filtroEdicao.registro"
      placeholder="Filtrar por número">
  </div>
  <div class="campo" *ngIf="operacaoFiltro === 7">
    <label for="filtroCpfBalcao">CPF Vendedor</label>
    <input id="filtroCpfBalcao" pInputText type="text" [(ngModel)]="filtroEdicao.descricao"
      placeholder="Filtrar por CPF do vendedor">
  </div>
  <div class="campo" *ngIf="operacaoFiltro === 10">
    <label for="filtroNumeroOs">Número O.S.</label>
    <input id="filtroNumeroOs" pInputText type="text" [(ngModel)]="filtroEdicao.registro"
      placeholder="Filtrar por número da O.S.">
  </div>
  <div class="campo" *ngIf="operacaoFiltro === 10">
    <label for="filtroIdOs">ID Número O.S.</label>
    <input id="filtroIdOs" pInputText type="text" [(ngModel)]="filtroEdicao.descricao"
      placeholder="Filtrar pelo ID da O.S.">
  </div>
  <div class="campo" *ngIf="rotuloFiltroRegistro(operacaoFiltro)">
    <label for="filtroRegistroExtra">{{ rotuloFiltroRegistro(operacaoFiltro) }}</label>
    <input id="filtroRegistroExtra" pInputText type="text" [(ngModel)]="filtroEdicao.registro"
      [placeholder]="'Filtrar por ' + rotuloFiltroRegistro(operacaoFiltro)">
  </div>
  <div class="campo" *ngIf="operacaoFiltro === 22">
    <label for="filtroItemRequisicao">Cód. Item</label>
    <input id="filtroItemRequisicao" pInputText type="text" [(ngModel)]="filtroEdicao.descricao"
      placeholder="Filtrar por código do item">
  </div>
  <div class="campo" *ngIf="!monitorReal(operacaoFiltro)">
    <label for="filtroRegistro">Registro</label>
    <input id="filtroRegistro" pInputText type="text" [(ngModel)]="filtroEdicao.registro"
      placeholder="Filtrar por registro">
  </div>
  <div class="campo" *ngIf="!monitorReal(operacaoFiltro)">
    <label for="filtroDescricao">Descrição</label>
    <input id="filtroDescricao" pInputText type="text" [(ngModel)]="filtroEdicao.descricao"
      placeholder="Filtrar por descrição">
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Limpar" icon="pi pi-trash" class="p-button-text"
      (click)="limparFiltroMonitor()"></button>
    <button pButton type="button" label="Filtrar" icon="pi pi-check" class="p-button-text"
      (click)="confirmarFiltroMonitor()"></button>
    <button pButton type="button" label="Cancelar" icon="pi pi-times" class="p-button-text"
      (click)="exibirFiltroMonitor = false"></button>
  </ng-template>
</p-dialog>

<p-dialog [header]="tituloEmpresa" [(visible)]="exibirEmpresa" [modal]="true" [style]="{width: '32rem'}"
  [draggable]="false">
  <ng-container *ngIf="empresaEdicao">
  <div class="campo">
    <label for="codEmpresa">Cód. Empresa</label>
    <input id="codEmpresa" pInputText type="text" [ngModel]="empresaEdicao?.codEmpresa" [disabled]="true">
  </div>
  <div class="campo">
    <label for="nomeEmpresa">Empresa</label>
    <input id="nomeEmpresa" pInputText type="text" [ngModel]="empresaEdicao?.nome" [disabled]="true">
  </div>
  <div class="campo">
    <label for="cnpjEmpresa">CNPJ</label>
    <input id="cnpjEmpresa" pInputText type="text" [ngModel]="empresaEdicao?.cnpj" [disabled]="true">
  </div>
  <div class="campo">
    <label for="codDealerEmpresa">Cód. Dealer</label>
    <input id="codDealerEmpresa" pInputText type="text" [ngModel]="empresaEdicao?.codDealer" [disabled]="true">
  </div>
  <div class="campo">
    <label for="ambienteEmpresa">Ambiente</label>
    <p-dropdown inputId="ambienteEmpresa" [options]="ambientes" optionLabel="label" optionValue="value"
      [(ngModel)]="empresaEdicao.ambiente" appendTo="body" [style]="{'width':'100%'}"
      [disabled]="visualizandoEmpresa"></p-dropdown>
  </div>
  <div class="campo campo-check">
    <p-checkbox [(ngModel)]="empresaEdicao.ativo" [binary]="true" inputId="ativoEmpresa"
      [disabled]="visualizandoEmpresa"></p-checkbox>
    <label for="ativoEmpresa">Ativo</label>
  </div>
  </ng-container>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Alterar" *ngIf="visualizandoEmpresa" icon="pi pi-file" class="p-button-text"
      (click)="habilitarEdicaoEmpresa()"></button>
    <button pButton type="button" label="Salvar" *ngIf="!visualizandoEmpresa" icon="pi pi-check" class="p-button-text"
      (click)="salvarEmpresa()"></button>
    <button pButton type="button" label="Cancelar" icon="pi pi-times" class="p-button-text"
      (click)="exibirEmpresa = false"></button>
  </ng-template>
</p-dialog>

<p-dialog [header]="tituloOperacao"
  [(visible)]="exibirOperacao" [modal]="true" [style]="{width: '32rem'}" [draggable]="false">
  <div class="campo">
    <label for="codOperacao">Código</label>
    <input id="codOperacao" pInputText type="number" [(ngModel)]="operacaoEdicao.codOperacao"
      [disabled]="codigoOperacaoDesabilitado">
  </div>
  <div class="campo">
    <label for="descricaoOperacao">Descrição</label>
    <input id="descricaoOperacao" pInputText type="text" [(ngModel)]="operacaoEdicao.descricao"
      [disabled]="visualizandoOperacao">
  </div>
  <div class="campo" *ngIf="operacaoEdicao.codOperacao === 23">
    <label for="horarioOperacao">Horário (HH:MM)</label>
    <input id="horarioOperacao" pInputText type="text" [(ngModel)]="operacaoEdicao.horario" placeholder="08:00"
      [disabled]="visualizandoOperacao">
  </div>
  <div class="campo campo-check">
    <p-checkbox [(ngModel)]="operacaoEdicao.ativo" [binary]="true" inputId="ativoOperacao"
      [disabled]="visualizandoOperacao"></p-checkbox>
    <label for="ativoOperacao">Ativo</label>
  </div>
  <div class="campo campo-check">
    <p-checkbox [(ngModel)]="operacaoEdicao.visualizarMonitor" [binary]="true" inputId="visualizarMonitor"
      [disabled]="visualizandoOperacao"></p-checkbox>
    <label for="visualizarMonitor">Visualizar no Monitor</label>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Alterar" *ngIf="visualizandoOperacao" icon="pi pi-file" class="p-button-text"
      (click)="habilitarEdicaoOperacao()"></button>
    <button pButton type="button" label="Salvar" *ngIf="!visualizandoOperacao" icon="pi pi-check" class="p-button-text"
      (click)="salvarOperacao()"></button>
    <button pButton type="button" label="Cancelar" icon="pi pi-times" class="p-button-text"
      (click)="exibirOperacao = false"></button>
  </ng-template>
</p-dialog>

<p-dialog [header]="tituloCruzamento"
  [(visible)]="exibirCruzamento" [modal]="true" [style]="{width: '32rem'}" [draggable]="false">
  <div class="campo">
    <label for="empresaCruzamento">Empresa</label>
    <p-dropdown inputId="empresaCruzamento" [options]="empresasParaCruzamento" optionLabel="rotulo" [(ngModel)]="empresaSelecionada"
      placeholder="Selecione a empresa" [filter]="true" filterBy="rotulo" appendTo="body" [style]="{'width':'100%'}"
      [disabled]="visualizandoCruzamento"></p-dropdown>
  </div>
  <div class="campo">
    <label for="operacaoCruzamento">Operação</label>
    <p-dropdown inputId="operacaoCruzamento" [options]="operacoesParaCruzamento" optionLabel="rotulo"
      [(ngModel)]="operacaoSelecionada" placeholder="Selecione a operação" [filter]="true" filterBy="rotulo"
      appendTo="body" [style]="{'width':'100%'}" [disabled]="visualizandoCruzamento"></p-dropdown>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Alterar" *ngIf="visualizandoCruzamento" icon="pi pi-file" class="p-button-text"
      (click)="habilitarEdicaoCruzamento()"></button>
    <button pButton type="button" label="Salvar" *ngIf="!visualizandoCruzamento" icon="pi pi-check" class="p-button-text"
      (click)="salvarCruzamento()"></button>
    <button pButton type="button" label="Cancelar" icon="pi pi-times" class="p-button-text"
      (click)="exibirCruzamento = false"></button>
  </ng-template>
</p-dialog>

<p-dialog header="Configurações" [(visible)]="exibirConfiguracao" [modal]="true" [style]="{width: '36rem'}"
  [draggable]="false" styleClass="dialog-configuracao-extrator">
  <p class="config-cabecalho" *ngIf="cruzamentoConfiguracao">
    <span>
      {{ cruzamentoConfiguracao.codEmpresa }} - {{ cruzamentoConfiguracao.nomeDealer }}
      <br>
      {{ cruzamentoConfiguracao.operacao }}
    </span>
    <button pButton pRipple type="button" icon="pi pi-cog"
      class="p-button-text p-button-secondary p-btn-sm botao-dias-monitor"
      [pTooltip]="'Dias no Monitor: ' + configuracaoEdicao.diasMonitor" tooltipPosition="left"
      (click)="abrirDiasMonitor()"></button>
  </p>  
  <div class="campo">
    <label for="tipoIntegracao">Tipo de integração</label>
    <p-dropdown inputId="tipoIntegracao" [options]="tiposIntegracao" optionLabel="label" optionValue="value"
      [(ngModel)]="configuracaoEdicao.tipoIntegracao" appendTo="body" [style]="{'width':'100%'}"></p-dropdown>
  </div>
  <div class="campo campo-check">
    <p-checkbox [(ngModel)]="configuracaoEdicao.usaDataInicio" [binary]="true" inputId="usaDataInicio"></p-checkbox>
    <label for="usaDataInicio">Usa data de início</label>
  </div>
  <div class="campo" *ngIf="configuracaoEdicao.usaDataInicio">
    <label for="dataInicioEnvio">Data para início envio</label>
    <p-calendar inputId="dataInicioEnvio" [(ngModel)]="configuracaoEdicao.dataInicio" dateFormat="dd/mm/yy"
      [showIcon]="true" icon="pi pi-calendar" [style]="{'width':'100%'}" [yearNavigator]="true"
      [monthNavigator]="true" yearRange="2000:2030" showButtonBar="true" appendTo="body"
      panelStyleClass="calendario-extrator" [baseZIndex]="10000000"></p-calendar>
  </div>
  <div class="campo">
    <label for="urlHomologacao">Url Homologação</label>
    <input id="urlHomologacao" pInputText type="text" [(ngModel)]="configuracaoEdicao.urlHomologacao">
  </div>
  <div class="campo">
    <label for="urlProducao">Url Produção</label>
    <input id="urlProducao" pInputText type="text" [(ngModel)]="configuracaoEdicao.urlProducao">
  </div>
  <div class="campo">
    <label for="grupoEmail">Grupo de e-mail</label>
    <p-dropdown inputId="grupoEmail" [options]="gruposEmail" optionLabel="descricao" optionValue="idGrupo"
      [(ngModel)]="configuracaoEdicao.idGrupoEmail" appendTo="body" [style]="{'width':'100%'}"
      placeholder="Selecione" [filter]="true" filterBy="descricao"
      emptyMessage="Nenhum grupo sincronizado" emptyFilterMessage="Nenhum grupo encontrado"></p-dropdown>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" icon="pi pi-times" class="p-button-text"
      (click)="exibirConfiguracao = false"></button>
    <button pButton type="button" label="Confirmar" icon="pi pi-check" (click)="salvarConfiguracao()"></button>
  </ng-template>
</p-dialog>

<p-dialog header="Dias no Monitor" [(visible)]="exibirDiasMonitor" [modal]="true" [style]="{width: '32rem'}"
  [contentStyle]="{maxHeight: '70vh', overflow: 'auto'}" [draggable]="false" [baseZIndex]="100000">
  <div class="campo">
    <label for="diasMonitor">Quantidade de dias</label>
    <input id="diasMonitor" pInputText type="number" min="1" max="365" [(ngModel)]="diasMonitorEdicao">
  </div>
  <p class="dias-monitor-aviso">Usado na primeira leitura do Monitor desta empresa. O padrão é 30. A quantidade segue junto ao confirmar a configuração.</p>
  <div class="limpeza-monitor" *ngIf="cruzamentoConfiguracao && monitorReal(cruzamentoConfiguracao.codOperacao)">
    <span class="limpeza-titulo">Limpar cópia do Monitor</span>
    <div class="campo-check">
      <p-radioButton name="limpezaMonitor" value="PERIODO" [(ngModel)]="limpezaModo" inputId="limpezaPeriodo"></p-radioButton>
      <label for="limpezaPeriodo">Por período</label>
    </div>
    <div class="campo-check">
      <p-radioButton name="limpezaMonitor" value="ULTIMO" [(ngModel)]="limpezaModo" inputId="limpezaUltimo"></p-radioButton>
      <label for="limpezaUltimo">Deixar apenas o último detalhe de cada movimento</label>
    </div>
    <div class="campo-check">
      <p-radioButton name="limpezaMonitor" value="TUDO" [(ngModel)]="limpezaModo" inputId="limpezaTudo"></p-radioButton>
      <label for="limpezaTudo">Tudo</label>
    </div>
    <div class="campo-datas" *ngIf="limpezaModo === 'PERIODO'">
      <div class="campo">
        <label for="limpezaInicio">De</label>
        <p-calendar inputId="limpezaInicio" [(ngModel)]="limpezaInicio" dateFormat="dd/mm/yy" [showIcon]="true"
          icon="pi pi-calendar" [style]="{'width':'100%'}" [yearNavigator]="true" [monthNavigator]="true"
          yearRange="2000:2030" showButtonBar="true" appendTo="body" panelStyleClass="calendario-extrator"
          [baseZIndex]="10000000"></p-calendar>
      </div>
      <div class="campo">
        <label for="limpezaFim">Até</label>
        <p-calendar inputId="limpezaFim" [(ngModel)]="limpezaFim" dateFormat="dd/mm/yy" [showIcon]="true"
          icon="pi pi-calendar" [style]="{'width':'100%'}" [yearNavigator]="true" [monthNavigator]="true"
          yearRange="2000:2030" showButtonBar="true" appendTo="body" panelStyleClass="calendario-extrator"
          [baseZIndex]="10000000"></p-calendar>
      </div>
    </div>
    <p class="dias-monitor-aviso" *ngIf="limpezaModo === 'PERIODO'">Apaga os movimentos desta empresa cuja data de integração cai no período, e os detalhes desses movimentos.</p>
    <p class="dias-monitor-aviso" *ngIf="limpezaModo === 'ULTIMO'">Mantém a grade. Apaga as tentativas antigas e deixa a mais recente de cada movimento.</p>
    <p class="dias-monitor-aviso" *ngIf="limpezaModo === 'TUDO'">Apaga movimentos e detalhes desta empresa e operação na cópia do Monitor. A cópia do Oracle na revenda permanece.</p>
    <p class="dias-monitor-aviso" *ngIf="limpezaResultado">{{ limpezaResultado }}</p>
    <button pButton type="button" id="limparCopiaMonitor" label="Excluir" icon="pi pi-trash" class="p-button-danger p-button-text"
      (click)="confirmarLimpezaMonitor()"></button>
  </div>
  <p class="dias-monitor-aviso limpeza-monitor" *ngIf="cruzamentoConfiguracao && !monitorReal(cruzamentoConfiguracao.codOperacao)">Esta operação não tem cópia no Monitor.</p>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" icon="pi pi-times" class="p-button-text"
      (click)="exibirDiasMonitor = false"></button>
    <button pButton type="button" label="Confirmar" icon="pi pi-check" (click)="confirmarDiasMonitor()"></button>
  </ng-template>
</p-dialog>

<p-dialog header="Detalhes" [(visible)]="exibirDetalheCliente" [modal]="true"
  [style]="{width: 'min(72rem, 96vw)'}" [contentStyle]="{maxHeight: '78vh', overflow: 'auto'}"
  [draggable]="false">
  <div class="detalhe-cliente" *ngIf="balcaoDetalhe">
    <div class="detalhe-campo"><span>Empresa</span><strong>{{ balcaoDetalhe.nomeEmpresa }}</strong></div>
    <div class="detalhe-campo"><span>Número / Série</span><strong>{{ balcaoDetalhe.numero }} / {{ balcaoDetalhe.serie }}</strong></div>
    <div class="detalhe-campo"><span>Vendedor</span><strong>{{ balcaoDetalhe.vendedor || '-' }}</strong></div>
    <div class="detalhe-campo"><span>CPF Vendedor</span><strong>{{ balcaoDetalhe.cpfVendedor || '-' }}</strong></div>
    <div class="detalhe-campo"><span>Cliente</span><strong>{{ balcaoDetalhe.cliente || '-' }}</strong></div>
    <div class="detalhe-campo"><span>Operação</span><strong>{{ balcaoDetalhe.operacao || '-' }}</strong></div>
    <div class="detalhe-campo"><span>Movimento</span><strong>{{ balcaoDetalhe.codMovimento }}</strong></div>
    <div class="detalhe-campo"><span>Marca</span><strong>{{ balcaoDetalhe.marca || '-' }}</strong></div>
    <div class="detalhe-campo"><span>Enviado</span><strong>{{ rotuloEnviado(balcaoDetalhe.enviado) }}</strong></div>
    <div class="detalhe-campo"><span>Erros</span><strong>{{ balcaoDetalhe.errosEnvio }}</strong></div>
    <div class="detalhe-campo"><span>Data emissão</span><strong>{{ balcaoDetalhe.dataEmissao || '-' }}</strong></div>
    <div class="detalhe-campo"><span>Data integração</span><strong>{{ balcaoDetalhe.dataIntegracao || '-' }}</strong></div>
    <div class="detalhe-campo"><span>Última atualização</span><strong>{{ balcaoDetalhe.dataUltimaAtualizacao || '-' }}</strong></div>
  </div>
  <div class="detalhe-cliente" *ngIf="operacaoDetalhe">
    <div class="detalhe-campo" *ngFor="let coluna of colunasOperacao(operacaoDetalhe.codOperacao)">
      <span>{{ coluna.titulo }}</span><strong>{{ valorColuna(operacaoDetalhe, coluna) }}</strong>
    </div>
  </div>
  <div class="detalhe-cliente" *ngIf="osDetalhe">
    <div class="detalhe-campo"><span>Empresa</span><strong>{{ osDetalhe.nomeEmpresa }}</strong></div>
    <div class="detalhe-campo"><span>Número O.S.</span><strong>{{ osDetalhe.numeroOs }}</strong></div>
    <div class="detalhe-campo"><span>ID Número O.S.</span><strong>{{ osDetalhe.idNumeroOs }}</strong></div>
    <div class="detalhe-campo"><span>Tipo O.S.</span><strong>{{ osDetalhe.descTipoOs || '-' }}</strong></div>
    <div class="detalhe-campo"><span>Consultor</span><strong>{{ osDetalhe.consultor || '-' }}</strong></div>
    <div class="detalhe-campo"><span>Cliente</span><strong>{{ osDetalhe.cliente || '-' }}</strong></div>
    <div class="detalhe-campo"><span>Movimento</span><strong>{{ osDetalhe.codMovimento }}</strong></div>
    <div class="detalhe-campo"><span>Marca</span><strong>{{ osDetalhe.marca || '-' }}</strong></div>
    <div class="detalhe-campo"><span>Enviado</span><strong>{{ rotuloEnviado(osDetalhe.enviado) }}</strong></div>
    <div class="detalhe-campo"><span>Erros</span><strong>{{ osDetalhe.errosEnvio }}</strong></div>
    <div class="detalhe-campo"><span>Data integração</span><strong>{{ osDetalhe.dataIntegracao || '-' }}</strong></div>
    <div class="detalhe-campo"><span>Data atualização</span><strong>{{ osDetalhe.dataUltimaAtualizacao || '-' }}</strong></div>
  </div>
  <div class="detalhe-cliente" *ngIf="compraDetalhe">
    <div class="detalhe-campo">
      <span>Empresa</span>
      <strong>{{ compraDetalhe.nomeEmpresa }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Número / Série</span>
      <strong>{{ compraDetalhe.numero }} / {{ compraDetalhe.serie }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Cód. Controle</span>
      <strong>{{ compraDetalhe.codControle || '-' }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Cliente</span>
      <strong>{{ compraDetalhe.cliente || '-' }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Operação</span>
      <strong>{{ compraDetalhe.operacao || '-' }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Movimento</span>
      <strong>{{ compraDetalhe.codMovimento }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Marca</span>
      <strong>{{ compraDetalhe.marca || '-' }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Enviado</span>
      <strong>{{ rotuloEnviado(compraDetalhe.enviado) }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Erros</span>
      <strong>{{ compraDetalhe.errosEnvio }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Data emissão</span>
      <strong>{{ compraDetalhe.dataEmissao || '-' }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Data integração</span>
      <strong>{{ compraDetalhe.dataIntegracao || '-' }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Última atualização</span>
      <strong>{{ compraDetalhe.dataUltimaAtualizacao || '-' }}</strong>
    </div>
  </div>
  <div class="detalhe-cliente" *ngIf="produtivoDetalhe">
    <div class="detalhe-campo">
      <span>Empresa</span>
      <strong>{{ produtivoDetalhe.nomeEmpresa }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Técnico</span>
      <strong>{{ produtivoDetalhe.codTecnico }} - {{ produtivoDetalhe.nome }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>CPF</span>
      <strong>{{ produtivoDetalhe.cpf || '-' }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Data admissão</span>
      <strong>{{ produtivoDetalhe.dataAdmissao || '-' }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Movimento</span>
      <strong>{{ produtivoDetalhe.codMovimento }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Marca</span>
      <strong>{{ produtivoDetalhe.marca || '-' }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Enviado</span>
      <strong>{{ rotuloEnviado(produtivoDetalhe.enviado) }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Erros</span>
      <strong>{{ produtivoDetalhe.errosEnvio }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Data integração</span>
      <strong>{{ produtivoDetalhe.dataIntegracao || '-' }}</strong>
    </div>
  </div>
  <div class="detalhe-cliente" *ngIf="clienteDetalhe">
    <div class="detalhe-campo">
      <span>Empresa</span>
      <strong>{{ clienteDetalhe.nomeEmpresa }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Cliente</span>
      <strong>{{ clienteDetalhe.codCliente }} - {{ clienteDetalhe.nome }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Movimento</span>
      <strong>{{ clienteDetalhe.codMovimento }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Marca</span>
      <strong>{{ clienteDetalhe.marca || '-' }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Enviado</span>
      <strong>{{ rotuloEnviado(clienteDetalhe.enviado) }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Erros</span>
      <strong>{{ clienteDetalhe.errosEnvio }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Data integração</span>
      <strong>{{ clienteDetalhe.dataIntegracao || '-' }}</strong>
    </div>
    <div class="detalhe-campo">
      <span>Última atualização</span>
      <strong>{{ clienteDetalhe.dataUltimaAtualizacao || '-' }}</strong>
    </div>
  </div>
  <p-table [value]="detalhesCliente" selectionMode="single" [(selection)]="detalheSelecionado" dataKey="chave"
    [scrollable]="true" scrollHeight="16rem"
    styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines detalhe-tentativas">
    <ng-template pTemplate="header">
      <tr>
        <th>Data da integração</th>
        <th>Tipo envio</th>
        <th>Status</th>
        <th>Versão</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-detalhe>
      <tr [pSelectableRow]="detalhe">
        <td>{{ detalhe.dataTentativa }}</td>
        <td>{{ detalhe.descricaoEnvio }}</td>
        <td>
          <span *ngIf="detalhe.descricaoStatus" class="status-badge" [ngClass]="classeStatus(detalhe.descricaoStatus)">{{ detalhe.descricaoStatus }}</span>
        </td>
        <td>{{ detalhe.versao }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4">{{ textoSemTentativa() }}</td>
      </tr>
    </ng-template>
  </p-table>
  <p-tabView styleClass="detalhe-abas">
    <p-tabPanel header="Mensagem">
      <div class="detalhe-copia">
        <button pButton type="button" icon="pi pi-copy" class="p-button-text p-button-sm"
          pTooltip="Copiar" tooltipPosition="left"
          (click)="copiarDetalhe(detalheSelecionado?.mensagem)"></button>
      </div>
      <textarea class="detalhe-texto" readonly [value]="textoDetalhe(detalheSelecionado?.mensagem)"></textarea>
    </p-tabPanel>
    <p-tabPanel header="Dados enviado">
      <div class="detalhe-copia">
        <button pButton type="button" icon="pi pi-copy" class="p-button-text p-button-sm"
          pTooltip="Copiar" tooltipPosition="left"
          (click)="copiarDetalhe(detalheSelecionado?.envio)"></button>
      </div>
      <textarea class="detalhe-texto" readonly [value]="textoDetalhe(detalheSelecionado?.envio)"></textarea>
    </p-tabPanel>
    <p-tabPanel header="Dados recebido">
      <div class="detalhe-copia">
        <button pButton type="button" icon="pi pi-copy" class="p-button-text p-button-sm"
          pTooltip="Copiar" tooltipPosition="left"
          (click)="copiarDetalhe(detalheSelecionado?.retorno)"></button>
      </div>
      <textarea class="detalhe-texto" readonly [value]="textoDetalhe(detalheSelecionado?.retorno)"></textarea>
    </p-tabPanel>
  </p-tabView>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Reenviar" icon="pi pi-replay"
      [disabled]="!clienteDetalhe && !produtivoDetalhe && !compraDetalhe && !balcaoDetalhe && !osDetalhe && !operacaoDetalhe" (click)="reenviarDetalhe()"></button>
  </ng-template>
</p-dialog>
<p-menu #menuReenviar [popup]="true" [model]="opcoesReenviar" appendTo="body"></p-menu>
